import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const removeBankAccountReq = (tokens: any, userAccessToken: string, dataObj: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.removeBankAccount,
    method: 'POST',
    config: sitConfig(tokens),
    body: dataObj,
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken ?? '',
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { removeBankAccountReq }
